import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
function Label(t0) {
  const $ = _c(17);
  let children;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      text: t1,
      className: t2,
      children,
      required: t3,
      id: t4,
      htmlFor: t5,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  const text = t1 === undefined ? "Label" : t1;
  const className = t2 === undefined ? "" : t2;
  const required = t3 === undefined ? false : t3;
  const id = t4 === undefined ? "" : t4;
  const htmlFor = t5 === undefined ? "" : t5;
  const t6 = `block 2xl:text-sm/6 text-xs font-medium text-[#4B5563] my-1 ${className}`;
  const t7 = children || text;
  let t8;
  if ($[8] !== required) {
    t8 = required && <span className="text-red-500 ml-0.5">*</span>;
    $[8] = required;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== htmlFor || $[11] !== id || $[12] !== props || $[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
    t9 = <label htmlFor={htmlFor} id={id} className={t6} {...props}>{t7}{t8}</label>;
    $[10] = htmlFor;
    $[11] = id;
    $[12] = props;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}
Label.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  required: PropTypes.bool,
  id: PropTypes.string,
  htmlFor: PropTypes.string
};
export default Label;